/* eslint-disable class-methods-use-this */
// eslint-disable-next-line no-unused-vars
import React from 'react';
import urlUtils from 'utils/Url';
import cookieUtils from 'utils/Cookies';
import dateUtils from 'utils/Date';
import { wrapComponent } from 'utils/framework';
import store from 'store/Store';

import BaseClass from 'components/BaseClass';
import Storage from 'utils/localStorage/Storage';

import Empty from 'constants/empty';
import anaConsts from 'analytics/constants';
import anaUtils from 'analytics/utils';
import UI from 'utils/UI';

// Rakuten recommends 730 days
const DEFAULT_COOKE_LIFETIME = anaConsts.AFFILIATE_PARAMETERS.AFFILIATE_COOKIE_LIFETIME;

class AffiliatesMain extends BaseClass {
    isBasketEmpty() {
        const basket = store.getState().basket;

        return !basket?.items || basket.items.length === 0;
    }

    isAffiliateGatewayLinkshare() {
        try {
            const url = new URL(window.location.href);

            return url.pathname === '/affiliatesgateway' && url.searchParams.get('site') === 'linkshare';
        } catch {
            return false;
        }
    }

    componentDidMount() {
        /**
         * iOS Safari ITP temporarily workaround:
         * After affiliate redirects, Safari may temporarily treat the site as third-party
         * under Intelligent Tracking Prevention (ITP), delaying access to first-party cookies.
         *
         * We trigger a one-time reload on the affiliate gateway page to ensure first-party
         * context is restored before continuing the redirect flow.
         */
        const shouldApplyIOSSafariITPReload = UI.isIOSSafari() && this.isAffiliateGatewayLinkshare() && this.isBasketEmpty();

        if (shouldApplyIOSSafariITPReload) {
            const IOS_RELOAD_FLAG = 'ios_affiliate_reload_once';
            const url = new URL(window.location.href);
            const hasReloaded = Storage.session.getItem(IOS_RELOAD_FLAG) || url.searchParams.has(IOS_RELOAD_FLAG);

            if (!hasReloaded) {
                try {
                    Storage.session.setItem(IOS_RELOAD_FLAG, '1');
                    url.searchParams.set(IOS_RELOAD_FLAG, '1');

                    window.location.replace(url.toString());

                    return;
                } catch (e) {
                    url.searchParams.set(IOS_RELOAD_FLAG, '1');
                    window.location.replace(url.toString());

                    return;
                }
            }
        }

        const params = urlUtils.getParams();
        const redirectUrl = (params.url && params.url[0]) || '/';
        const siteId = (params.siteID && params.siteID[0]) || '';

        const cookiesLifetime = this.props.linkshareCookiesLifetime || DEFAULT_COOKE_LIFETIME;
        // date must be in UTC
        const linkShareTime = dateUtils.formatISODateVariation();

        // Resets any previous stored parameters
        anaUtils.resetAffiliateGatewayParams();

        // Stores the affiliate parameters received so the TMS (Adobe Launch can send them to GA4)
        Storage.local.setItem(
            anaConsts.AFFILIATE_PARAMETERS.AFFILIATE_PARAMETERS_STORAGE,
            {
                params,
                referrer: document.referrer || Empty.String,
                sotToRead: '1',
                linkshareTimeStamp: linkShareTime,
                gatewayLink: window?.location?.href || Empty.String,
                redirectUrl,
                siteId
            },
            DEFAULT_COOKE_LIFETIME * Storage.DAYS
        );

        // Append linkShareTime with "|siteID" per CE requerment (ILLUPH-126746)
        cookieUtils.write(anaConsts.AFFILIATE_PARAMETERS.AFFILIATE_LINKSHARETIME_COOKIE, `${linkShareTime}|${siteId}`, cookiesLifetime, false);
        siteId && cookieUtils.write(anaConsts.AFFILIATE_PARAMETERS.AFFILIATE_SITEID_COOKIE, siteId, cookiesLifetime, false);
        urlUtils.redirectTo(redirectUrl);
    }

    render() {
        return null;
    }
}

export default wrapComponent(AffiliatesMain, 'AffiliatesMain', true);
